export function myAccountPage() {
  if (!document.body.classList.contains('type-MyAccount')) return;

  buildMyAccountNav();
}

function buildMyAccountNav() {
  const Main = document.getElementById('Main');
  if (!Main) return;

  if (Main.querySelector('.wl-myaccount-nav')) return;

  const accountLinks = document.querySelectorAll('#MyAccountWrapper .nav-myaccount ul li a');
  if (!accountLinks.length) return;

  const nav = document.createElement('nav');
  nav.className = 'wl-myaccount-nav wl-added';

  const ul = document.createElement('ul');

  accountLinks.forEach(link => {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = link.getAttribute('href');
    a.textContent = link.textContent.trim();

    if (window.location.pathname === a.getAttribute('href')) {
      li.classList.add('active');
    }

    li.appendChild(a);
    ul.appendChild(li);
  });

  nav.appendChild(ul);
  Main.prepend(nav);
}
